import Head from 'expo-router/head';

import { MoreScreen } from '../../../../components/more-screen/more-screen';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function AccountRoute() {
  return (
    <>
      <Head>
        <title>More - Firehouse Subs</title>
      </Head>
      <MoreScreen />
    </>
  );
}
